// ======================================================================
// File Name       : Detail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';

const Category = ({ label, indent, notBold }) => {
  const paddingLeft = indent && indent > 0 && `${15 * indent}px`;
  const fontWeight = notBold ? 'normal' : 'bold';
  return (
    <Form.Group className="form-info">
      <Col as={Form.Label} sm={3}>
        <b style={{ fontWeight, paddingLeft }}>
          {label}
        </b>
      </Col>
    </Form.Group>
  );
};

Category.propTypes = {
  label: PropTypes.string,
  indent: PropTypes.number,
  notBold: PropTypes.bool,
};

Category.defaultProps = {
  label: '',
  indent: 0,
  notBold: false,
};

const Item = ({ name, value, indent, labelSize, valueSize, className, formClassName, hidden }) => {
  if (hidden) return null; // Step 12.0.0 TAS-18710

  const paddingLeft = indent && indent > 0 && `${15 * indent}px`;
  return (
    <Form.Group className={`form-info ${formClassName}`}>
      <Col as={Form.Label} sm={labelSize || 3} className={className} >
        <div style={{ paddingLeft }}>
          {name}
        </div>
      </Col>
      <Col as={Form.Label} sm={valueSize || 9}>
        {value}
      </Col>
    </Form.Group>
  );
};

Item.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  indent: PropTypes.number,
};

Item.defaultProps = {
  name: '',
  value: '',
  indent: 0,
};

export { Category, Item };
